import { Injectable } from "@angular/core";
import { AnalyticsProvider } from "./analytics-provider.interface";

@Injectable()
export class ConsoleProvider implements AnalyticsProvider {

    testingMode: boolean = false;

    dispatch(event: string, payload?: any): void {
        if (this.testingMode) {
            console.log('[Analytics]', event, payload);
        }
    }


}
